const ValidationMessages = {
  firstNameAlphaNumeric: "First Name can only contain alphanumeric characters!",
  firstNameRequired: "First Name is required!",
  firstNameAlphabets: "First Name must contain only alphabets",
  lastNameAlphaNumeric: "Last Name can only contain alphanumeric characters!",
  lastNameRequired: "Last Name is required!",
  emailFormatRequired: "Email must be in the format: name@geoparking.com!",
  emailRequired: "Email is required!",
  emailVerify: "Email verification not completed",
  validEmail: 'Please enter a valid email',
  phoneRequired: "Mobile number is required!",
  OfficePhone: "Office Number is invalid",
  inValidPhone: "Mobile number is invalid!",
  mobileVerify: "Mobile verification not completed",
  departmentRequired: "Department is required!",
  termsAndConditons: "You must agree to the terms and conditions!",
  zipCodeDigits: "ZIP Code must contain only digits!",
  zipCode5: "ZIP Code must be 5 digits long!",
  validZip: "Valid 5-digit ZIP code is required",
  zipCodeAddreess: "Zipcode does not match the address provided!",
  tempcredentials: "Entered temporary credentials are invalid",
  lastNameAlphabets: "Last Name must contain only alphabets!",
  titleRequired: "Title is required",
  titleAlphabets: "Title must contain only alphabets!",
  newPasswordRequired: 'NewPassword is required!',
  oldandnewPassword: "Cannot be same as the old password",
  newPassword: "Please enter the new password",
  currentPassword: "Please enter the current password",
  confirmPassword: "Please enter the confirm password",
  confirmPasswordRequired: 'ConfirmPassword is required!',
  newandconfirmPasswordShouldMatch: 'New Password and Confirm Password should Match!',
  passwordRequired: "Password is required!",
  OTPRequired: "Please enter a valid OTP.",
  UserNameRequired: 'UserName is required',
  passwordAttempts: 'Too many incorrect login attempts. Please try again in 3 minutes',
  validemailorpassword: 'Please enter a valid email/password',
  InValidCredential: "Please Verify Entered Credentials!",
  emailAlredyExist: "Email already Exist!",
  emailInvalid: "Email is invalid",
  requirements: "Password does not meet all requirements",
  correctPassword: "Please enter the correct password and try again!",
  tryAgain: "Something went wrong please try again",
  passwordConstraint: 'Password must be at least 8 characters long',
  passwordRequirements: 'Password must include at least one uppercase letter, one lowercase letter, one number, and one special character',
  noLoginFound: 'No LoggedInUser found',
  entityName: "Entity Name is required",
  entityNameConstraints: "Entity Name cannot contain special characters",
  entityletteranddigitd: "Entity Name should contain letters and may contain digits",
  entitydigits: "Entity Name cannot contain only digits",
  entitydots: "Entity Name cannot contain only dots",
  entitycon: "Entity Name cannot contain only &",
  entitymailrequired: "Entity Mailing Address is required",
  entitymailingadd: "Entity Mailing Address is invalid",
  mailingaddressrequired: "Mailing Address is required",
  mailingConstraints: "Mailing Address cannot contain special characters",
  countryRequired: "Country is required",
  statereq: "State is required",
  stateConstraints: "State cannot contain special characters",
  cityReq: "City is required",
  cityConstraints: "City cannot contain special characters",
  cityMatch: "City does not match the address provided",
  zipReq: "ZIP Code is required",
  bankNameRequired: 'Bank Name is required',
  alphabetsOnly: 'Please enter alphabets only',
  accountHolder: 'Account Holder Name is required',
  accountType: 'Account Type is required',
  accountNumber: 'Account Number is required',
  accountDigits: 'Account Number must be between 8 and 12 digits',
  routingNum: 'Routing Number is required',
  routdigits: 'Routing Number must be exactly 9 digits',
  accountAddress: 'Address associated with the Account is required',
  accountTypeFormat: 'Please check the Account Type format',
  terms: 'Please agree to the terms and conditions to proceed.',
  nicknameProp: "Please enter a property nickname",
  agreeService: "Agree Terms of Service",
  agreeUse: "Agree Terms of Use",
  passwordMatch: "Please ensure the Passwords match",
  message: "The message has been sent successfully!!",
  email: "The email has been sent successfully!!",
  prop: 'Please select Atleast one property.',
  psl: "Please select a PSL - Parking Space Location marker.",
  marker: "Please select a marker to proceed.",
  actionIrreversible: 'Are you sure you want to delete this property? This action is irreversible.',
  proceed: 'Once you proceed, you will not be able to undo this action. Please confirm if you wish to continue.',
  propInactive: 'Are you sure you want to mark this property as inactive?',
  makeActive: 'You can make it active again in the future if you wish. Please confirm if you wish to continue.',
  propActive: 'Are you sure you want to mark this property as active?',
  confirmContinue: 'Please confirm if you wish to continue.',
  termsservice: "Terms of Service is required",
  termsuse: "Terms of Uses is required",
  firstnameAndAlphabets: "First Name: Required, alphabets only",
  lastnameAndAlphabets: "Last Name: Required, alphabets only",
  titleAndAlphabets: "Title is Required",
  fivedigitOTP: "Please Enter 5 Digit OTP!",
  uploadFileReq: "Please upload the PDF file",
  deletePricing:"Are you sure you want to delete this pricing plan? This action is irreversible.",
  pricingInactive:"Are you sure you want to mark this pricing plan as inactive?",
  pricingActive:"Are you sure you want to mark this pricing plan as active?",
  confirmPricing:"Are you sure you want to assign this pricing plan to the parking lot?",

};

export default ValidationMessages;